import type { FC } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { getBiView, getBiComponent } from '../../helpers/bilogger';
import { PlaygroundSubsection, StudioSection } from '../../types/store';
import App from '../../components/App';
import Studio from '../Studio';
import StashFolder from '../StashFolder';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

export interface Props {
  activeSection: StudioSection;
  activePlaygroundSubsection: PlaygroundSubsection;
  isStashVisitorView: boolean;
  language: string;
}

/* We use this wrapper as a sort of router which renders the page we need depending on redux state */
const StudioWrapper: FC<Props> = ({
  activeSection,
  activePlaygroundSubsection,
  isStashVisitorView,
  language,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const url = new URL(window.location.href);
    const isNew = url.searchParams.get('new') === '1';
    const isSettings = url.searchParams.get('settings') === '1';

    if (isNew && url.pathname.endsWith('/published/galleries')) {
      dispatch(
        pushModal(ModalType.STUDIO_FOLDER, {
          params: { folderType: 'gallery' },
        })
      );
    }

    if (isSettings && url.pathname.endsWith('/published/galleries')) {
      dispatch(
        pushModal(ModalType.GALLERY_DISPLAY_SETTINGS, {
          biContext: { sectionname: 'studio' },
        })
      );
    }
  }, [dispatch]);
  return (
    <BiLoggerContextProvider
      value={{
        component: getBiComponent(
          activeSection,
          activePlaygroundSubsection,
          isStashVisitorView,
          undefined
        ),
        view: getBiView(isStashVisitorView),
      }}
    >
      <App language={language}>
        {isStashVisitorView && <StashFolder />}
        {!isStashVisitorView && <Studio />}
      </App>
    </BiLoggerContextProvider>
  );
};
StudioWrapper.displayName = 'StudioWrapper';

export default StudioWrapper;
